import React from 'react'
import SupplyBillAgreeIco from '../../../../supplyBill/view/items/SupplyBillAgreeIco'
import { Tooltip } from '@mui/material'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import RemoveIcon from '@mui/icons-material/Remove';

const SupplyOrderItemAgree = ({ supplyOrderItem }) => {
  return (
    <div>
        {
            supplyOrderItem ? 
                supplyOrderItem.isAgreeDirector && supplyOrderItem.isAgreeDirector === true ? 
                    <p className={`supplyAgrees__agree`}>
                        <Tooltip title='Погоджено директором'>
                            <AddCircleOutlineIcon />
                        </Tooltip>
                    </p>
                :
                !supplyOrderItem.isAgreeDirector && supplyOrderItem.isAgreeDirector === false ? 
                    <p className={`supplyAgrees__disagree`}>
                        <Tooltip title={`Не погоджено директором: ${supplyOrderItem.disagreeDirectorText}`}>
                            <RemoveCircleIcon />
                        </Tooltip>
                    </p>
                : 
                    <p className={`supplyAgrees__approval`}>
                        <Tooltip title='Очікує погодження директором'>
                            <RemoveIcon />
                        </Tooltip>
                    </p>
            : ''
        }
    </div>
  )
}

export default SupplyOrderItemAgree